package com.example.event_management_system.data.models

import kotlinx.serialization.Serializable

@Serializable
data class Location(
    val id: String = "",
    val name: String = "",
    val address: String? = null,
    val phone: String? = null,
    val email: String? = null,
    val senderEmail: String? = null,
    val replyToEmail: String? = null,
    val ccEmails: List<String> = emptyList(),
    val bccEmails: List<String> = emptyList(),
    val logoUrl: String? = null,
    val emailBodyTemplate: String? = null,
    val emailSignatureLine: String? = null,
    val ownerId: String = "",
    @kotlinx.serialization.Serializable(with = LongAsDoubleSerializer::class)
    val createdAt: Long = 0L,
    val isActive: Boolean = true
)
